<template>
  <div class="layout">
    <div class="layout__header">
      <h3>Abono</h3>
    </div>
    <div class="row">
      <div class="col-xs-12 col-md-6">
        <div class="form-field">
          <div class="datepicker-field">
            <date-picker type="date" format="dd-MM-yyyy" id="fecha" v-model="form.fecha_abono" lang="es"></date-picker>
            <label>Fecha de abono *</label>
            <span v-if="errores.fecha_abono" class="helper-text text-danger" slot="helper">
              <strong>{{ errores.fecha_abono[0] }}</strong>
            </span>
          </div>
        </div>
        <div class="form-field">
          <input-field vMoney :format="money2" v-model="form.valor" id="valor" placeholder="$ ##.##">
            <span>Valor</span>
            <span v-if="errores.valor" class="helper-text text-danger" slot="helper">
              <strong>{{ errores.valor[0] }}</strong>
            </span>
          </input-field>
        </div>
        <div v-show="form.tipo_abono !== 'EF'" class="form-field">
          <input-field v-model="form.banco_retencion" id="bancoRetencion" placeholder="Escriba un banco o retención...">
            <span>Banco/Retención</span>
            <span v-if="errores.banco_retencion" class="helper-text text-danger" slot="helper">
              <strong>{{ errores.banco_retencion[0] }}</strong>
            </span>
          </input-field>
        </div>
        <div v-show="form.tipo_abono === 'EF'" class="form-field">
          <input-field :value="vuelto" vMoney :format="money2" id="vuelto" placeholder="$ ##.##" readonly>
            <span>Vuelto</span>
          </input-field>
        </div>
      </div>
      <div class="col-xs-12 col-md-6">
        <div class="form-field select">
          <div class="select-field">
            <!-- <v-select v-model="selectedTipoAbono" id="tipo" placeholder="Seleccione..." label="nombre" :options="tiposAbono"></v-select> -->
            <select name="tipo" id="tipo" v-model="form.tipo_abono">
              <option :value="tipo.id" v-for="tipo in tiposAbono" :key="tipo.id">
                {{ tipo.nombre }}
              </option>
            </select>
            <label for="tipo">Tipo de abono *</label>
            <span v-if="errores.tipo_abono" class="helper-text text-danger" slot="helper">
              <strong>{{ errores.tipo_abono[0] }}</strong>
            </span>
          </div>
        </div>
        <div class="form-field">
          <textarea-field v-model="form.obs_referencia" placeholder="..." id="detalle">
            <span>Observación / Referencia</span>
            <span v-if="errores.obs_referencia" class="helper-text text-danger" slot="helper">
              <strong>{{ errores.obs_referencia[0] }}</strong>
            </span>
          </textarea-field>
        </div>
        <div class="form-field">
          <input-field :value="saldoFinal" vMoney :format="money2" id="saldoAbono" placeholder="$ ##.##" readonly>
            Saldo
          </input-field>
        </div>
      </div>
    </div>
    <div class="modal-buttons">
      <button @click="cancelar" class="btn-danger btn--text" type="button"><i class="fa fa-close"></i><span>Cerrar</span></button>
      <button @click="aceptar" class="btn-success" type="button"><i class="fa fa-check"></i><span>Aceptar</span></button>
    </div>
  </div>
</template>

<script>
export default {
    props : {
        idComprobante : {
            type : String,
            required : true
        },  
        value : {
            required : false,
            default : function () {
                return {
                    fecha_abono : moment(new Date()).format('YYYY-MM-DD'),
                    tipo_abono : '',
                    valor : 0, 
                    obs_referencia : '',
                    banco_retencion : '',
                    id_abono : '',
                    id_comprobante : this.idComprobante
                }
            }
        },
        saldo : {
            required : true
        }
    },
    data : function () {
        return {
            form : this.value,
            tiposAbono : [
                {
                    id : 'EF',
                    nombre : 'Efectivo'
                },
                {
                    id : 'CH',
                    nombre : 'Cheque'
                },
                {
                    id : 'DEP',
                    nombre : 'Depósito bancario'
                },
                {
                    id : 'CRE',
                    nombre : 'Tarjeta de crédito'
                },
                {
                    id : 'DEB',
                    nombre : 'Tarjeta de débito'
                },
                {
                    id : 'TRANS',
                    nombre : 'Transferencia'
                },
                {
                    id : 'RET',
                    nombre : 'Retención'
                }
            ],
            money2 : money,
            selectedTipoAbono : null,
            errores : {
                fecha_abono : undefined,
                tipo_abono : undefined,
                valor : undefined, 
                obs_referencia : undefined,
                banco_retencion : undefined
            },
            url : url,
            saldoFinal : this.saldo
        };
    },
    methods : {
        aceptar : function () {
            let valor = parseFloat(this.form.valor);
            if (isNaN(valor))
                valor = 0;
            if (valor === 0 || (this.form.tipo_abono !== 'EF' && valor > parseFloat(this.saldoFinal))) {
                swal('El valor no puede ser igual a cero ni mayor al saldo del comprobante, por favor ingrese el valor corréctamente.', 'Mensaje', 'warning');
                return;
            }
            let that = this;
            let urlRequest = this.url + '/abonos';
            if (this.form.id_abono !== '' && this.form.id_abono !== undefined && this.form.id_abono !== null) 
            {
                urlRequest += '/' + this.form.id_abono;
                this.form._method = 'PUT';
            }
            else 
                this.form._method = undefined;
            let finalForm = JSON.parse(JSON.stringify(this.form));
            if (this.form.tipo_abono === 'EF' && this.vuelto > 0)
                finalForm.valor = parseFloat(finalForm.valor) - this.vuelto;
            axios.post(urlRequest, finalForm).then(function (response) {
                that.$emit('aceptar', that.form);
            }).catch(function (error) {
                if (error !== undefined && error !== null) {
                    let response = error.response;
                    if (response !== null && response !== undefined) {
                        let status = response.status;
                        if (status === 422) {
                            swal('No se puede continuar, el formulario posee errores.', 'Alerta', 'warning');
                            that.errores = response.data.errors;
                        }
                        else 
                            swal('Hubo un error al almacenar los datos.', 'Mensaje', 'error');
                    }
                }
            });
        },
        cancelar : function () {
            this.$emit('cancelar');
        }
    },
    watch : {
        'form.tipo_abono' : function (value) {
            if (value === 'EF')
                this.form.banco_retencion = '';
        }
    },
    mounted : function () {
        this.form.id_comprobante = this.idComprobante;
        for (let i = 0; i < this.tiposAbono.length; i++) 
            if (this.tiposAbono[i].id === this.form.tipo_abono) {
                this.selectedTipoAbono = this.tiposAbono[i];
                break;
            }
        this.saldoFinal = round(parseFloat(this.saldoFinal) + parseFloat(this.form.valor));
    },
    computed : {
        vuelto : function () {
            let vuelto = 0;
            let diferencia = parseFloat(this.saldoFinal) - parseFloat(this.form.valor);
            if (!isNaN(diferencia) && diferencia < 0)
                vuelto = diferencia * -1; 
            return round(vuelto);
        }
    }
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/comprobantes/Abono.vue